import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const cityTabs = {
    $triggerTab: $('.js-city-tabs-title'),

    init: function () {
        let $this = this
        this.$triggerTab.on('click', function () {
            let _this = $(this)
            let target = _this.attr('id').split('tab_').pop()

            //First remove .is-active for all tabs and accordions
            $this.$triggerTab.removeClass('is-active')
            $('.js-city-tab-item').removeClass('is-active')

            //Add .is-active for the clicked tab title
            _this.addClass('is-active')

            //Add .is-active only for the content related to this tab title
            $(`#tab_panel${target}`).addClass('is-active')

            //Refresh all fading effects
            ScrollTrigger.refresh()
        })
    },
}

cityTabs.init()
